import React from 'react';
import { Card, Typography, Tag, Space, Divider, Row, Col } from 'antd';
import { CopyButton } from './CopyButton';

const { Title, Text } = Typography;

export const CardTaller = ({ item }) => {
  const getTipoColor = (tipo) => {
    return tipo === 'AG' ? 'blue' : 'green';
  };

  const direccionCompleta = `${item.calle || ''} ${item.numeroExterior || ''}${item.numeroInterior && item.numeroInterior !== 'nan' ? ` Int. ${item.numeroInterior}` : ''}, ${item.colonia || ''}, ${item.alcaldiaMunicipio || ''}, CP ${item.cp || ''}`;

  return (
    <Card style={{ marginBottom: 16 }}>
      <Space direction="vertical" style={{ width: '100%' }} size="small">
        <div>
          <Title level={4} style={{ marginTop: 0, marginBottom: 4, display: 'inline-block' }}>
            {item.nombreComercial}
          </Title>
          <Tag color={getTipoColor(item.tipoProveedor)} style={{ marginLeft: 8 }}>
            {item.tipoProveedor === 'AG' ? 'AGENCIA' : 'TALLER'}
          </Tag>
        </div>

        <div>
          <Text type="secondary">{item.razonSocial}</Text>
        </div>

        <div>
          <Tag color="cyan">{item.marcaTaller}</Tag>
          {item.tipoVehiculo && <Tag color="orange">{item.tipoVehiculo}</Tag>}
          {item.estatus && <Tag color={item.estatus === 'ACTIVO' ? 'success' : 'default'}>{item.estatus}</Tag>}
        </div>

        <Divider style={{ margin: '12px 0' }} />

        <Row gutter={[8, 8]}>
          {item.contacto && item.contacto !== 'nan' && (
            <Col span={12}>
              <div>
                <Text strong>Contacto</Text>
                <br />
                <Text>{item.contacto}</Text>
                <CopyButton text={item.contacto} />
              </div>
            </Col>
          )}
          <Col span={item.contacto && item.contacto !== 'nan' ? 12 : 24}>
            <div>
              <Text strong>Teléfono</Text>
              <br />
              <Text>{item.tel1}</Text>
              <CopyButton text={item.tel1} />
            </div>
          </Col>
        </Row>

        {item.tel2 && item.tel2 !== 'nan' && (
          <div>
            <Text strong>Teléfono 2</Text>
            <br />
            <Text>{item.tel2}</Text>
            <CopyButton text={item.tel2} />
          </div>
        )}

        <div>
          <Text strong>Email</Text>
          <br />
          <Text>{item.email}</Text>
          <CopyButton text={item.email} />
        </div>

        <Divider style={{ margin: '12px 0' }} />

        <div>
          <Text strong>Dirección</Text>
          <br />
          <Text>{direccionCompleta}</Text>
          <CopyButton text={direccionCompleta} />
        </div>

        {item.latitud && item.longitud && (
          <div>
            <Text strong>Coordenadas</Text>
            <br />
            <Text type="secondary">{item.latitud}, {item.longitud}</Text>
            <CopyButton text={`${item.latitud}, ${item.longitud}`} />
          </div>
        )}
      </Space>
    </Card>
  );
};
